import { useState } from 'react'

/**
 * Custom hook for public landing page state management
 */
export const usePublicLanding = () => {
  const [query, setQuery] = useState('')
  const [placeResult, setPlaceResult] = useState(null)
  const [open, setOpen] = useState(false)
  const [loader, setLoader] = useState(false)

  const googleApiKey = import.meta.env.VITE_GOOGLE_APIKEY

  const toggleOpen = () => {
    setOpen(!open)
  }

  const searchProperty = () => {
    setLoader(true)
    let location = {
      street_number: 'long_name',
      route: 'long_name',
      administrative_area_level_1: 'short_name',
      locality: 'long_name',
      postal_code: 'long_name',
    }

    if (placeResult) {
      for (
        let i = 0;
        i < placeResult.address_components.length;
        i++
      ) {
        const addressType = placeResult.address_components[i].types[0]
        if (location[addressType])
          location[addressType] =
            placeResult.address_components[i][location[addressType]]
      }
      for (var prop in location) {
        if (Object.prototype.hasOwnProperty.call(location, prop)) {
          if (
            location[prop] === 'long_name' ||
            location[prop] === 'short_name'
          )
            location[prop] = ''
        }
      }
    }

    const streetAddress = placeResult
      ? location.street_number + ' ' + location.route
      : query

    window.location.href = `/publicproperty/Summary?address=${streetAddress}&city=${location.locality}&state=${location.administrative_area_level_1}&zip=${location.postal_code}`
  }

  return {
    query,
    setQuery,
    placeResult,
    setPlaceResult,
    open,
    loader,
    setLoader,
    googleApiKey,
    toggleOpen,
    searchProperty,
  }
}
